import { createContext } from 'react';

import { CounselorAndMeritBadge } from '@appTypes/esb/advancements/v2/meritBadges/counselors/youths/assigned';
import { OnSubmitRequirements } from '@modules/youthProfile/types';

export const AdvRequirementsContext = createContext<{
  isIneligibleAdvancement: boolean;
  isNotAllowedEditor: boolean;
  canApproveAdvancements: boolean;
  isYouthEditor: boolean;
  appUserId: number | null;
  youthUserId: string | number | null;
  isProcessingAdvancements: boolean;
  shouldStopLoading: boolean;
  updatingYouthAdvancement: boolean;
  minimumCompletionDate: object | null;
  submitRequirements: OnSubmitRequirements;
  advancementType: null | string;
  advancementId: null | number;
  programId: number | null;
  isAdvancementInYouthRecord: boolean;
  activeVersionId: string | number | null;
  ranks: { id: number }[];
  selectedRankIndex: null | number;
  organizationGuid: null | string;
  parsedStatus: null | string;
  counselorsData: {
    isLoadingYouthCounselors: boolean;
    counselor: CounselorAndMeritBadge | null;
    userIsCounselor: boolean | null;
  };
  youthMemberId: number | null;
  overrideExpiryDate: boolean;
}>({
  isIneligibleAdvancement: false,
  isNotAllowedEditor: false,
  canApproveAdvancements: false,
  isYouthEditor: false,
  appUserId: null,
  youthUserId: null,
  shouldStopLoading: false,
  isProcessingAdvancements: false,
  updatingYouthAdvancement: false,
  minimumCompletionDate: null,
  submitRequirements: () => null,
  advancementType: null,
  advancementId: null,
  programId: null,
  isAdvancementInYouthRecord: false,
  activeVersionId: null,
  ranks: [],
  selectedRankIndex: -1,
  organizationGuid: null,
  parsedStatus: null,
  counselorsData: {
    isLoadingYouthCounselors: false,
    counselor: null,
    userIsCounselor: false,
  },
  youthMemberId: null,
  overrideExpiryDate: false,
});
